export default __webpack_public_path__ + "static/media/5.36c9bb02.png";